import { Directive, ElementRef, Input, HostListener, Renderer2, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[mascaraVisual]'
})
export class MascaraVisualDirective implements OnChanges, AfterViewInit {
  @Input() mascaraVisual: 'texto' | 'correo' = 'texto';
  @Input() activarMascara: boolean = false;

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private renderer: Renderer2
  ) {}

  // 1. Detecta cambios cuando Angular inyecta los datos precargados
  ngOnChanges(changes: SimpleChanges) {
    if (changes['activarMascara'] || changes['mascaraVisual']) {
      this.aplicarMascara();
    }
  }

  // 2. Se asegura de aplicar la máscara al renderizar la vista
  ngAfterViewInit() {
    setTimeout(() => {
      this.aplicarMascara();
    }, 100);
  }

  // 3. Al entrar: Quita la máscara para que el usuario pueda editar si quiere
  @HostListener('focus') onFocus() {
    if (this.activarMascara && this.control.value) {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.control.value);
    }
  }

  // 4. Al salir: Vuelve a poner la máscara
  @HostListener('blur') onBlur() {
    this.aplicarMascara();
  }

  private aplicarMascara() {
    // Si el control no existe o no hay valor, limpiamos y salimos
    if (!this.control || !this.control.value) {
      return;
    }

    const valorReal = this.control.value;
    
    if (this.activarMascara) {
      const enmascarado = this.mascaraVisual === 'correo' 
        ? this.enmascararCorreo(valorReal) 
        : this.enmascararTexto(valorReal);
          
      this.renderer.setProperty(this.el.nativeElement, 'value', enmascarado);
    } else {
      // Si la máscara está apagada, forzamos el valor real
      this.renderer.setProperty(this.el.nativeElement, 'value', valorReal);
    }
  }

  private enmascararTexto(texto: string): string {
    const limpio = String(texto).trim();
    if (limpio.length <= 2) return limpio.charAt(0) + '***';
    return `${limpio.charAt(0)}***${limpio.charAt(limpio.length - 1)}`;
  }

  private enmascararCorreo(correo: string): string {
    const stringCorreo = String(correo);
    if (!stringCorreo || !stringCorreo.includes('@')) return stringCorreo;
    
    const [nombre, dominio] = stringCorreo.split('@');

    let nombreMask = nombre.length > 2 
      ? `${nombre.charAt(0)}***${nombre.charAt(nombre.length - 1)}` 
      : `${nombre.charAt(0)}***`;
      
    return `${nombreMask}@${dominio}`;
  }
}